module.exports = __webpack_public_path__ + "img/img4.1c31cc34.png";